var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3278 5.40125L6.38077 10.1143C4.14277 24.2413 17.3278 30.4022 17.3278 30.4022C17.3278 30.4022 29.9188 25.4283 28.2758 10.1143L17.3278 5.40125Z",
    stroke: "#535455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2744 16.9045H13.2744V21.9045H21.2744V16.9045Z",
    stroke: "#535455"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7741 16.9045V14.8175C14.7181 14.4567 14.7408 14.0881 14.8406 13.7369C14.9405 13.3858 15.1152 13.0605 15.3527 12.7832C15.5902 12.5059 15.8849 12.2833 16.2166 12.1307C16.5483 11.9781 16.909 11.899 17.2741 11.899C17.6392 11.899 18 11.9781 18.3317 12.1307C18.6633 12.2833 18.958 12.5059 19.1956 12.7832C19.4331 13.0605 19.6078 13.3858 19.7076 13.7369C19.8075 14.0881 19.8302 14.4567 19.7741 14.8175V16.9015",
    stroke: "#535455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/Privacy.61b80983.svg";
export { ForwardRef as ReactComponent };